<template>
  <router-view />
</template>

<script>
export default {
  name: 'Child'
}
</script>



// WEBPACK FOOTER //
// src/components/Child.vue